import React from 'react'

import { Alert, AlertTitle } from '@material-ui/lab'
import { Grid } from '@material-ui/core'

import { parseMarkdown } from 'utils'

const MensagemSistema = ({ mensagem }) => {
  return (
    <Grid item xs>
      <Alert severity={(mensagem.tipo == 'U' ? "error" : (mensagem.tipo == 'A' ? "warning" : (mensagem.tipo == 'I' ? "info" : "error")))}>
        <AlertTitle>
          <strong>{mensagem.titulo}</strong>
        </AlertTitle>
        { <div dangerouslySetInnerHTML={{ __html: parseMarkdown(mensagem.textoMensagem) }} /> }
      </Alert>
    </Grid>
  )
}

export default MensagemSistema
